/* eslint-disable class-methods-use-this */
/* https://github.com/kensnyder/quill-image-resize-module */
/* The MIT License
Copyright © 2018

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the “Software”), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
export class BaseModule {
  constructor(resizer) {
    this.overlay = resizer.overlay;
    this.img = resizer.img;
    this.options = resizer.options;
    this.requestUpdate = resizer.onUpdate;
  }
  /*
      requestUpdate (passed in by the library during construction, above) can be used to let the library know that
      you've changed something about the image that would require re-calculating the overlay (and all of its child
      elements)

      For example, if you add a margin to the element, you'll want to call this or else all the controls will be
      misaligned on-screen.
   */

  /*
      onCreate will be called when the element is clicked on

      If the module has any user controls, it should create any containers that it'll need here.
      The overlay has absolute positioning, and will be automatically repositioned and resized as needed, so you can
      use your own absolute positioning and the 'top', 'right', etc. styles to be positioned relative to the element
      on-screen.
   */
  onCreate = () => {};

  /*
      onDestroy will be called when the element is de-selected, or when this module otherwise needs to tidy up.

      If you created any DOM elements in onCreate, please remove them from the DOM and destroy them here.
   */
  onDestroy = () => {};

  /*
      onUpdate will be called any time that the element is changed (e.g. resized, aligned, etc.)

      This frequently happens during resize dragging, so keep computations light while here to ensure a smooth
      user experience.
   */
  onUpdate = () => {};
}
